export default __webpack_public_path__ + "static/media/UNI.122b46d7.svg";